// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setCustomGrowthAmount } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/custom-growth-amount/custom-growth-amount.actions';
// Constants
import { DEFAULT_CUSTOM_GROWTH_AMOUNT } from 'ChartApp/ts/features/fundamental-chart/constants';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const customGrowthAmount = createReducer(DEFAULT_CUSTOM_GROWTH_AMOUNT, on(setChartData, (state, { chartData }) => chartData.params.customGrowthAmount), on(setCustomGrowthAmount, (state, action) => {
    return action.customGrowthAmount;
}));
